var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-text',[_c('v-card',[_c('v-card-text',[_c('contact-fields-table',{attrs:{"contactFields":_vm.contactFields,"contactFieldsCount":_vm.contactFieldsCount,"isLoading":_vm.isLoading},on:{"updateContactFields":_vm.handleContactFieldsUpdate}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }